import { Flex } from '@chakra-ui/react';
import BedrockNavbar from '@components/layout/Navbar/BedrockNavbar/BedrockNavbar';

const BedrockLayout = ({ children }) => {
  return (
    <Flex flexDir="column" overflow="hidden" minH="100vh" justifyContent="flex-start" bg="white">
      <BedrockNavbar />
      {children}
    </Flex>
  );
};

export default BedrockLayout;
